module.exports = __webpack_public_path__ + "static/media/img_anli@2x.00e21b94.png";